<template>
  <div>
    <div class="button" @click="onBatchImportClick">
      <img class="import-icon" src="../../assets/img/import.svg" alt="">
      批量添加
    </div>
    <el-dialog
      title=""
      class="textarea-dialog"
      :visible.sync="textareaDialog"
      width="524px"
      >
      <span class="textarea-dialog-title">批量添加监控公司</span>
      <el-popover
        placement="right"
        title
        width="200"
        trigger="hover"
        :visible-arrow=false
        content="逗号、句号、空格、分号、换行视为不同空格">
        <img class="question-icon" src="../../assets/img/question-circle1.svg" alt="" slot="reference">
      </el-popover>
      <el-input
        type="textarea"
        :rows="16"
        placeholder="输入你想要监控的公司"
        v-model="companies">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button class="confirm-btn" @click="onNextBtnClick" :loading="nextBtnLoading">下一步</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title=""
      class="edit-dialog"
      :visible.sync="editDialog"
      width="560px"
      :before-close="handleCloseEeitDialog"
      v-if="editDialog"
      >
      <div class="correct-company-count">成功匹配 {{correctCompanyCount}} 家公司</div>
      <div class="wrong-company-count">有 <span class="count">{{showWrongCompanyCount}}</span> 家出现问题，请处理</div>
      <div v-for="(item, index) in errorResult" :key="index">
        <batch-add-monitor-item :showCompanyNameInput="(currentCompany===item.errorCompany || item.recommendCompanies.indexOf(currentCompany) > -1)&&indexData === index" @changeInput="changeInput" :companyName="item.errorCompany" :recommendCompanies="item.recommendCompanies" :index="index" @change="batchAddCompaniesList" @deleteCompany="emitDeleteCompany"></batch-add-monitor-item>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="onEditBackBtnClick">上一步</el-button>
        <el-button class="confirm-btn" @click="onEditOkBtnClick" :loading="editOkBtnLoading">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title=""
      class="success-dialog"
      :visible.sync="successDialog"
      width="524px"
      >
      <div class="success-header">
        <img class="success-icon" src="../../assets/img/success.svg">
        <span class="success-word">添加成功</span>
      </div>
      <div class="success-content">{{companiesCount}}家公司已经成功加入监控列表</div>
      <span slot="footer" class="dialog-footer">
        <el-button class="success-btn" @click="onconfirmOkBtnClick">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title=""
      class="warning-dialog"
      :visible.sync="warningDialog"
      width="524px"
      top="20vh"
      
      >
      <div class="warning-header">
        <img class="warning-icon" src="../../assets/img/warning1.svg">
        <span class="warning-word">提醒</span>
      </div>
      <div class="warning-content">关闭窗口将无法保留已经编辑的内容</div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="onWarningCancalBtnClick">取消</el-button>
        <el-button class="confirm-btn" @click="onWarningconfirmBtnClick">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import questionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';
import BatchAddMonitorItem from '@/components/news-monitor/BatchAddMonitorItem';


export default {
  data() {
    return {
      indexData: -2,
      queryObj: {
        pageNum: 1,
        pageSize: 10,
        groups: [],
        sortBy: '',
        sortOrder: ''
      },
      textareaDialog: false,
      editDialog: false,
      companies: '',
      companiesList: [],
      correctCompanyCount: 0,
      wrongCompanyCount: 0,
      showWrongCompanyCount: 0,
      errorResult: [],
      errorDataText: true,
      errorDataInput: false,
      batchCompaniesList: [],
      successDialog: false,
      companiesCount: 0,
      warningDialog: false,
      currentCompany: '',
      successCompanies: [],
      editOkBtnLoading: false,
      nextBtnLoading: false
    };
  },
  watch: {
    companies() {
      if (this.companies.indexOf('。') > -1) {
        this.companies = this.companies.replace('。', '\n');
      } else if (this.companies.indexOf('，') > -1) {
        this.companies = this.companies.replace('，', '\n');
      } else if (this.companies.indexOf(' ') > -1) {
        this.companies = this.companies.replace(' ', '\n');
      } else if (this.companies.indexOf(';') > -1) {
        this.companies = this.companies.replace(';', '\n');
      } else if (this.companies.indexOf(',') > -1) {
        this.companies = this.companies.replace(',', '\n');
      } else if (this.companies.indexOf('.') > -1) {
        this.companies = this.companies.replace('.', '\n');
      } else if (this.companies.indexOf('；') > -1) {
        this.companies = this.companies.replace('；', '\n');
      } 
    }
  },
  components: {
    BatchAddMonitorItem
  },
  methods: {
    changeInput(res) {
      this.currentCompany = res.companyNameData;
      this.indexData = res.indexData;
    },
    onWarningconfirmBtnClick() {
      this.warningDialog = false;
      this.editDialog = false;
      this.companies = '';
      this.batchCompaniesList = [];
    },
    onWarningCancalBtnClick() {
      this.warningDialog = false;
    },
    handleCloseEeitDialog() {
      this.warningDialog = true;
    },
    emitDeleteCompany(res) {
      if (res.isShowErrorIcon) {
        this.wrongCompanyCount--;
      }
      if (this.batchCompaniesList.indexOf(res.res) > -1) {
        this.batchCompaniesList.splice(this.batchCompaniesList.indexOf(res.res), 1);
      }
    },
    batchAddCompaniesList(res) {
      this.wrongCompanyCount--;
      this.batchCompaniesList.push(res.companyNameData);
      if (this.batchCompaniesList.indexOf(res.oldCompanyNameData) > -1) {
        this.batchCompaniesList.splice(this.batchCompaniesList.indexOf(res.oldCompanyNameData), 1);
        this.wrongCompanyCount++;
      }
    },
    onBatchImportClick() {
      this.textareaDialog = true;
    },
    onNextBtnClick() {
      if (!this.companies) {
        this.$message.warning('内容不能为空');
      } else {
        this.companiesList = this.companies.split('\n');
        for (let i = 0; i < this.companiesList.length; i++) {
          if (this.companiesList[i] === '') {
            this.companiesList.splice(i, 1);
            i--; 
          }
        }
        if (!this.companiesList.length) {
          this.$message.warning('内容不能为空');
          return;
        }
        this.currentCompany = '';
        this.nextBtnLoading = true;
        questionQuery.judgeAddMonitor(this.companiesList, this.username).then(res => {
          this.nextBtnLoading = false;
          this.correctCompanyCount = res.correctCompanyCount;
          this.wrongCompanyCount = res.wrongCompanyCount;
          this.showWrongCompanyCount = res.wrongCompanyCount;
          this.errorResult = res.Result;
          this.successCompanies = res.correctCompany;
          if (!this.wrongCompanyCount) {
            questionQuery.batchAddMonitor(this.batchCompaniesList.concat(this.successCompanies), this.username).then(result => {
              this.companiesCount = result.companiesCount;
              this.textareaDialog = false;
              this.successDialog = true;
            });
          } else {
            this.textareaDialog = false;
            this.editDialog = true;
          }
        });
      }
    },
    onEditClick() {
      this.errorDataText = false;
      this.errorDataInput = true;
    },
    onRecommendCompanie(res) {
      this.errorDataText = false;
      this.errorDataInput = false;
      this.trueDataText = true;
      this.trueData = res;
    },
    onEditOkBtnClick() {
      if (!this.wrongCompanyCount) {
        this.batchCompaniesList = this.successCompanies ? this.batchCompaniesList.concat(this.successCompanies) : this.batchCompaniesList;
        this.editOkBtnLoading = true;
        questionQuery.batchAddMonitor(this.batchCompaniesList, this.username).then(res => {
          this.editOkBtnLoading = false;
          this.companiesCount = res.companiesCount;
          this.editDialog = false;
          this.successDialog = true;
        });
      } else {
        this.$message.warning('存在问题公司没有修改');
      }
    },
    onEditBackBtnClick() {
      this.editDialog = false;
      this.textareaDialog = true;
      this.batchCompaniesList = [];
    },
    onconfirmOkBtnClick() {
      this.successDialog = false;
      this.companies = '';
      this.batchCompaniesList = [];
      questionQuery.getMonitorList(this.username, this.queryObj).then(data => {
        this.$emit('change', data.pageItems);
      });
    }
  },
  mounted() {
    this.username = authService.getLoggedUserName();
  }
};
</script>

<style lang="scss" scoped>
  .button {
    height: 26px;
    line-height: 26px;
    width: 94px;
    padding-left:10px;
    font-size: 14px;
    border-radius: 4px;
    color: #ffffff;
    background-color: #605e61;
    cursor: pointer;
    &:hover {
      background-color: #3e9dcc;
    }
    &:active {
      background-color: #2183b3;
    }
    .import-icon {
      display: inline-block;
      width: 13px;
      height: 12px;
      background-image: url("../../assets/img/import.svg");
      background-size: cover;
    }
  }
  .textarea-dialog {
    .textarea-dialog-title {
      margin-right: 5px;
      font-size: 20px;
      font-weight: bold;
      color: #ffffff;
    }
    .confirm-btn {
      height: 48px;
      width: 99px;
      padding: 0;
      font-size: 16px;
      color: #ffffff;
      background-color: #45a8cc;
      box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
      border-radius: 2px;
      border: none;
      &:hover {
        color: #ffffff;
        background-color: #3cbeed;
      }
      &:focus {
        color: #ffffff;
        background-color: #3cbeed;
      }
      &:active {
        color: #ffffff;
        background-color: #368cab;
      }
    }
    .question-icon {
      width: 14px;
      height: 14px;
      background-image: url("../../assets/img/question-circle1.svg");
      background-size: cover;
      &:hover {
        background-image: url("../../assets/img/question-circle.svg");
      }
    }
  }
  .edit-dialog {
    .correct-company-count {
      font-size: 20px;
      color: #40e4ff;
      font-weight: bold;
    }
    .wrong-company-count {
      padding: 8px 0 25px;
      color: #ffffff;
      font-size: 14px;
      .count {
        color: #fe4954;
      }
    }
    .el-dialog {
      border-radius: 8px;
      background-color: #333138;
      box-shadow: 0px 29px 50px 0px rgba(5, 69, 92, 0.1);
      .el-dialog__headerbtn {
        top: 26px;
      }
      .el-dialog__header {
        padding: 0;
        .el-dialog__title {
          color: #ffffff;
        }
      }
      .el-dialog__body {
        padding: 32px 0 0 32px;
      }
      .el-dialog__footer {
        padding: 42px 32px 32px 0px;
      }
    }
    .cancel-btn {
      height: 48px;
      width: 99px;
      padding: 0;
      font-size: 16px;
      color: #ffffff;
      background-color: #3b3a3f;
      border-radius: 2px;
      border: none;
      &:hover {
        color: #ffffff;
        background-color: #423f43;
      }
      &:focus {
        color: #ffffff;
        background-color: #423f43;
      }
      &:active {
        color: #ffffff;
        background-color: #38363c;
      }
    }
    .confirm-btn {
      height: 48px;
      width: 99px;
      padding: 0;
      font-size: 16px;
      color: #ffffff;
      background-color: #45a8cc;
      box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
      border-radius: 2px;
      border: none;
      &:hover {
        color: #ffffff;
        background-color: #3cbeed;
      }
      &:focus {
        color: #ffffff;
        background-color: #3cbeed;
      }
      &:active {
        color: #ffffff;
        background-color: #368cab;
      }
    }
  }
  .success-dialog {
    .success-header {
      .success-icon {
        width: 28px;
        height: 28px;
        vertical-align: middle;
      }
      .success-word {
        margin-left: 10px;
        font-size: 20px;
        letter-spacing: 1.3px;
        color: #ffffff;
        vertical-align: middle;
      }
    }
    .success-content {
      margin-top: 12px;
      font-size: 14px;
      letter-spacing: 0.9px;
      color: #ffffff;
    }
    .el-dialog {
      border-radius: 8px;
      background-color: #333138;
      box-shadow: 0px 29px 50px 0px rgba(5, 69, 92, 0.1);
      .el-dialog__headerbtn {
        top: 26px;
      }
      .el-dialog__header {
        padding: 0;
        .el-dialog__title {
          color: #ffffff;
        }
      }
      .el-dialog__body {
        padding: 32px 0 0 32px;
      }
      .el-dialog__footer {
        padding: 42px 32px 32px 0px;
      }
    }
  
    .success-btn {
      height: 48px;
      width: 99px;
      padding: 0;
      font-size: 16px;
      color: #ffffff;
      background-color: #45a8cc;
      box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
      border-radius: 2px;
      border: none;
      &:hover {
        color: #ffffff;
        background-color: #3cbeed;
      }
      &:focus {
        color: #ffffff;
        background-color: #3cbeed;
      }
      &:active {
        color: #ffffff;
        background-color: #368cab;
      }
    }
  }
  .warning-dialog {
    .warning-content {
      margin-top: 10px;
      font-size: 14px;
      letter-spacing: 0.9px;
      color: #ffffff;
    }
    .warning-header {
      .warning-icon {
        width: 32px;
        height: 32px;
        vertical-align: middle;
      }
      .warning-word {
        margin-left: 8px;
        font-size: 20px;
        letter-spacing: 1.3px;
        color: #ffffff;
        vertical-align: middle;
      }
    }
    .cancel-btn {
      height: 48px;
      width: 99px;
      padding: 0;
      font-size: 16px;
      color: #ffffff;
      background-color: #3b3a3f;
      border-radius: 2px;
      border: none;
      &:hover {
        color: #ffffff;
        background-color: #423f43;
      }
      &:focus {
        color: #ffffff;
        background-color: #423f43;
      }
      &:active {
        color: #ffffff;
        background-color: #38363c;
      }
    }
    .confirm-btn {
      height: 48px;
      width: 99px;
      padding: 0;
      font-size: 16px;
      color: #ffffff;
      background-color: #45a8cc;
      box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
      border-radius: 2px;
      border: none;
      &:hover {
        color: #ffffff;
        background-color: #3cbeed;
      }
      &:focus {
        color: #ffffff;
        background-color: #3cbeed;
      }
      &:active {
        color: #ffffff;
        background-color: #368cab;
      }
    }
  }
  .textarea-dialog /deep/.el-dialog .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 28px;
      right: 28px;
    }
  }
  .textarea-dialog /deep/.el-dialog .el-dialog__body {
    padding: 32px 32px 14px;
    .el-textarea {
      margin-top:16px;
      .el-textarea__inner {
        border: none;
      }
    }
  }
  .textarea-dialog /deep/.el-dialog .el-dialog__footer {
    padding: 10px 32px 34px 32px;
  }

  .edit-dialog /deep/.el-dialog .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 28px;
      right: 28px;
    }
  }
  .edit-dialog /deep/.el-dialog .el-dialog__body {
    padding: 32px 32px 23px;
  }
  .edit-dialog /deep/.el-dialog .el-dialog__footer {
    padding: 0 32px 33px 32px;
  }

  .warning-dialog /deep/.el-dialog .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 28px;
      right: 28px;
    }
  }
  .warning-dialog /deep/.el-dialog .el-dialog__body {
    padding: 32px 32px 24px;
  }
  .warning-dialog /deep/.el-dialog .el-dialog__footer {
    padding: 0 32px 32px;
  }
  
  .success-dialog /deep/.el-dialog .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 28px;
      right: 28px;
    }
  }
  .success-dialog /deep/.el-dialog .el-dialog__body {
    padding: 32px 32px 24px;
  }
  .success-dialog /deep/.el-dialog .el-dialog__footer {
    padding: 0 32px 32px;
  }
</style>



